import { LightningElement, api, wire } from "lwc";
import { hasAccessTokenResolver } from "@devforce/trailhead-client-auth";
import { getEmitter } from "@devforce/trailhead-client-events";
import {
  FavoriteMutation,
  UnfavoriteMutation,
} from "@devforce/trailhead-client-gql";
import { getLearningActions } from "common/contentActions";
import { LabelsAdapter } from "common/labelsAdapter";
import { memoizeOnce } from "common/memoize";
import {
  trackUserActivity,
  getUserActivityLearningActionPayload,
} from "common/track";
import { showToast } from "tds/toaster";

var data$9 = {
  action_details: "Details",
  action_favorite: "Favorit",
  action_favorite_success: '<a href="%{url}">Zu Favoriten hinzugefügt</a>',
  action_favorite_error:
    "Beim Hinzufügen dieses Elements zu Ihren Favoriten ist ein Problem aufgetreten.",
  action_unfavorite: "Aus Favoriten entfernen",
  action_unfavorite_success: '<a href="%{url}">Aus Favoriten entfernt</a>',
  action_unfavorite_error:
    "Beim Entfernen dieses Elements aus Ihren Favoriten ist ein Problem aufgetreten.",
  action_trailmix_add: "Zu Trailmix hinzufügen",
};
data$9.action_details;
data$9.action_favorite;
data$9.action_favorite_success;
data$9.action_favorite_error;
data$9.action_unfavorite;
data$9.action_unfavorite_success;
data$9.action_unfavorite_error;
data$9.action_trailmix_add;

var data$8 = {
  action_details: "Details",
  action_favorite: "Favorite",
  action_favorite_success: '<a href="%{url}">Added to Favorites</a>',
  action_favorite_error:
    "There was a problem adding this item to your favorites.",
  action_unfavorite: "Unfavorite",
  action_unfavorite_success: '<a href="%{url}">Removed from Favorites</a>',
  action_unfavorite_error:
    "There was a problem removing this item from your favorites.",
  action_trailmix_add: "Add to Trailmix",
};
data$8.action_details;
data$8.action_favorite;
data$8.action_favorite_success;
data$8.action_favorite_error;
data$8.action_unfavorite;
data$8.action_unfavorite_success;
data$8.action_unfavorite_error;
data$8.action_trailmix_add;

var data$7 = {
  action_details: "Detalles",
  action_favorite: "Establecer como favorito",
  action_favorite_success: '<a href="%{url}">Agregado a favoritos</a>',
  action_favorite_error:
    "Se produjo un problema al agregar este elemento a sus favoritos.",
  action_unfavorite: "Eliminar de favoritos",
  action_unfavorite_success: '<a href="%{url}">Eliminado de favoritos</a>',
  action_unfavorite_error:
    "Se produjo un problema al eliminar este elemento de sus favoritos.",
  action_trailmix_add: "Agregar a Trailmix",
};
data$7.action_details;
data$7.action_favorite;
data$7.action_favorite_success;
data$7.action_favorite_error;
data$7.action_unfavorite;
data$7.action_unfavorite_success;
data$7.action_unfavorite_error;
data$7.action_trailmix_add;

var data$6 = {
  action_details: "Detalles",
  action_favorite: "Establecer como favorito",
  action_favorite_success: '<a href="%{url}">Agregado a favoritos</a>',
  action_favorite_error:
    "Se produjo un problema al agregar este elemento a sus favoritos.",
  action_unfavorite: "Anular como favorito",
  action_unfavorite_success: '<a href="%{url}">Eliminado de favoritos</a>',
  action_unfavorite_error:
    "Se produjo un problema al eliminar este elemento de sus favoritos.",
  action_trailmix_add: "Agregar a Trailmix",
};
data$6.action_details;
data$6.action_favorite;
data$6.action_favorite_success;
data$6.action_favorite_error;
data$6.action_unfavorite;
data$6.action_unfavorite_success;
data$6.action_unfavorite_error;
data$6.action_trailmix_add;

var data$5 = {
  action_details: "Détails",
  action_favorite: "Ajouter aux favoris",
  action_favorite_success: '<a href="%{url}">Ajouté aux favoris</a>',
  action_favorite_error:
    "Nous avons rencontré un problème lors de l'ajout de cet élément à vos favoris.",
  action_unfavorite: "Retirer des favoris",
  action_unfavorite_success: '<a href="%{url}">Supprimé des favoris</a>',
  action_unfavorite_error:
    "Nous avons rencontré un problème lors de la suppression de cet élément de vos favoris.",
  action_trailmix_add: "Ajouter au Trailmix",
};
data$5.action_details;
data$5.action_favorite;
data$5.action_favorite_success;
data$5.action_favorite_error;
data$5.action_unfavorite;
data$5.action_unfavorite_success;
data$5.action_unfavorite_error;
data$5.action_trailmix_add;

var data$4 = {
  action_details: "Dettagli",
  action_favorite: "Aggiungi ai preferiti",
  action_favorite_success: '<a href="%{url}">Aggiunto ai preferiti</a>',
  action_favorite_error:
    "Si è verificato un problema durante l'aggiunta di questo elemento ai preferiti.",
  action_unfavorite: "Rimuovi dai preferiti",
  action_unfavorite_success: '<a href="%{url}">Rimosso dai preferiti</a>',
  action_unfavorite_error:
    "Si è verificato un problema durante la rimozione di questo elemento dai preferiti.",
  action_trailmix_add: "Aggiungi a Trailmix",
};
data$4.action_details;
data$4.action_favorite;
data$4.action_favorite_success;
data$4.action_favorite_error;
data$4.action_unfavorite;
data$4.action_unfavorite_success;
data$4.action_unfavorite_error;
data$4.action_trailmix_add;

var data$3 = {
  action_details: "詳細",
  action_favorite: "お気に入り",
  action_favorite_success: '<a href="%{url}">お気に入りに保存しました</a>',
  action_favorite_error: "この項目をお気に入りに追加できませんでした。",
  action_unfavorite: "お気に入りから削除",
  action_unfavorite_success: '<a href="%{url}">お気に入りから削除しました</a>',
  action_unfavorite_error: "この項目をお気に入りから削除できませんでした。",
  action_trailmix_add: "Trailmix に追加",
};
data$3.action_details;
data$3.action_favorite;
data$3.action_favorite_success;
data$3.action_favorite_error;
data$3.action_unfavorite;
data$3.action_unfavorite_success;
data$3.action_unfavorite_error;
data$3.action_trailmix_add;

var data$2 = {
  action_details: "세부 사항",
  action_favorite: "즐겨찾기",
  action_favorite_success: '<a href="%{url}">즐겨찾기에 추가되었습니다</a>',
  action_favorite_error:
    "이 항목을 즐겨찾기에 추가하는 중에 오류가 발생했습니다.",
  action_unfavorite: "즐겨찾기에서 삭제",
  action_unfavorite_success: '<a href="%{url}">즐겨찾기에서 삭제되었습니다</a>',
  action_unfavorite_error:
    "이 항목을 즐겨찾기에서 삭제하는 중에 오류가 발생했습니다.",
  action_trailmix_add: "Trailmix에 추가",
};
data$2.action_details;
data$2.action_favorite;
data$2.action_favorite_success;
data$2.action_favorite_error;
data$2.action_unfavorite;
data$2.action_unfavorite_success;
data$2.action_unfavorite_error;
data$2.action_trailmix_add;

var data$1 = {
  action_details: "Detalhes",
  action_favorite: "Favoritos",
  action_favorite_success: '<a href="%{url}">Adicionado a Favoritos</a>',
  action_favorite_error:
    "Houve um problema ao adicionar este item a Favoritos.",
  action_unfavorite: "Retirar de Favoritos",
  action_unfavorite_success: '<a href="%{url}">Removido de Favoritos</a>',
  action_unfavorite_error:
    "Houve um problema ao remover este item de Favoritos.",
  action_trailmix_add: "Adicionar a Trailmix",
};
data$1.action_details;
data$1.action_favorite;
data$1.action_favorite_success;
data$1.action_favorite_error;
data$1.action_unfavorite;
data$1.action_unfavorite_success;
data$1.action_unfavorite_error;
data$1.action_trailmix_add;

var data = {
  action_details: "详细信息",
  action_favorite: "收藏",
  action_favorite_success: '<a href="%{url}">已添加到收藏夹</a>',
  action_favorite_error: "将此项目添加到您的收藏夹时出现问题。",
  action_unfavorite: "从收藏夹删除",
  action_unfavorite_success: '<a href="%{url}">已从收藏夹删除</a>',
  action_unfavorite_error: "从您的收藏夹中删除此项目时出现问题。",
  action_trailmix_add: "添加到 Trailmix",
};
data.action_details;
data.action_favorite;
data.action_favorite_success;
data.action_favorite_error;
data.action_unfavorite;
data.action_unfavorite_success;
data.action_unfavorite_error;
data.action_trailmix_add;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

function isAuthenticated() {
  return hasAccessTokenResolver();
}
class contentActions extends LightningElement {
  @api config = null;
  @api summary = null;
  @api pageLocation = null;
  contentType = "";
  connectedCallback() {
    if (this.summary && this.summary.type) {
      this.contentType = this.summary.type;
    }
  }
  getMenuConfig = memoizeOnce(getLearningActions);
  get menuConfig() {
    return this.getMenuConfig(this.config);
  }
  get actionWithLabel() {
    let { menuConfig } = this;
    if (!menuConfig?.action) return null;
    return {
      ...menuConfig.action,
      label: this.labels[`action_${menuConfig.action.name}`],
    };
  }
  get actionsWithLabel() {
    let { menuConfig } = this;
    if (!menuConfig?.actions) return null;
    return menuConfig.actions.map((section) => ({
      ...section,
      actions: section.actions.map((action) => ({
        ...action,
        label: this.labels[`action_${action.name}`] || action.label,
      })),
    }));
  }
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = {};
  get labelOptions() {
    return {
      action_favorite_success: {
        url: "/users/favorites",
      },
      action_unfavorite_success: {
        url: "/users/favorites",
      },
    };
  }
  detailsModal = false;
  detailsModalConstructor = null;
  trailmixAddModal = false;
  trailmixAddModalConstructor = null;
  handleAction(event) {
    const action = event.detail;
    if (action.authRequired && !isAuthenticated()) {
      getEmitter().emit("login");
      return;
    }
    let pageLocation = this.pageLocation ?? "th-content-action";
    let payload = {};
    switch (action.name) {
      case "favorite":
        trackUserActivity(
          this,
          "favorite_clicked",
          getUserActivityLearningActionPayload(this.config.learning, {
            pageLocation,
          })
        );
        payload = this.handleFavorite();
        this.refocusActionsMenu(event);
        return payload;
      case "unfavorite":
        trackUserActivity(
          this,
          "unfavorite_clicked",
          getUserActivityLearningActionPayload(this.config.learning, {
            pageLocation,
          })
        );
        payload = this.handleUnfavorite();
        this.refocusActionsMenu(event);
        return payload;
      case "trailmix_add":
        trackUserActivity(
          this,
          "add_to_trailmix_clicked",
          getUserActivityLearningActionPayload(this.config.learning, {
            pageLocation,
          })
        );
        return this.handleTrailmixAdd();
      case "details":
        trackUserActivity(
          this,
          "details_clicked",
          getUserActivityLearningActionPayload(this.config.learning, {
            pageLocation,
          })
        );
        this.dispatchEvent(
          new CustomEvent("trailhead_details_modal_opened", {
            bubbles: true,
            composed: true,
          })
        );
        return this.handleDetails();
      default:
        this.dispatchActionEvent(event.detail);
        break;
    }
  }
  refocusActionsMenu(event) {
    event.currentTarget?.focus();
  }
  async handleFavorite() {
    try {
      let { getClient, gql } = await import(
        "@devforce/trailhead-client-apollo"
      );
      let optimisticResponse = {
        markAsFavorite: {
          __typename: "MarkAsFavoritePayload",
          // @ts-ignore
          learning: {
            ...this.config.learning,
            favorite: true,
          },
        },
      };
      await getClient().mutate({
        mutation: gql`
          ${FavoriteMutation}
        `,
        variables: {
          name: this.config.learning.name,
          type: this.config.learning.type,
        },
        optimisticResponse,
      });
    } catch {
      showToast({
        message: this.labels.action_favorite_error,
        variant: "error",
      });
    }
  }
  async handleUnfavorite() {
    try {
      let { getClient, gql } = await import(
        "@devforce/trailhead-client-apollo"
      );
      let optimisticResponse = {
        unfavorite: {
          __typename: "UnfavoritePayload",
          // @ts-ignore
          learning: {
            ...this.config.learning,
            favorite: false,
          },
        },
      };
      await getClient().mutate({
        mutation: gql`
          ${UnfavoriteMutation}
        `,
        variables: {
          name: this.config.learning.name,
          type: this.config.learning.type,
        },
        optimisticResponse,
      });
    } catch {
      showToast({
        message: this.labels.action_unfavorite_error,
        variant: "error",
      });
    }
  }
  handleDetails() {
    import("th/detailsModal")
      .then((m) => {
        this.detailsModal = true;
        this.detailsModalConstructor = m.default;
      })
      .catch(console.log);
  }
  handleTrailmixAdd() {
    import("th/trailmixAddModal")
      .then((m) => {
        this.trailmixAddModal = true;
        this.trailmixAddModalConstructor = m.default;
      })
      .catch(console.log);
  }
  dispatchActionEvent(action) {
    this.dispatchEvent(
      new CustomEvent("action", {
        detail: action,
      })
    );
  }
  refocusTrigger() {
    this.template
      .querySelector("*")
      ?.shadowRoot?.querySelector(".trigger")
      ?.focus();
  }
  handleDetailsModalClose() {
    this.dispatchEvent(
      new CustomEvent("trailhead_details_modal_closed", {
        bubbles: true,
        composed: true,
      })
    );
    this.detailsModal = false;
    this.refocusTrigger();
  }
  handleTrailmixAddModalClose() {
    this.trailmixAddModal = false;
    this.refocusTrigger();
  }
}

export default contentActions;
